import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { useCallback, useState } from 'react';


interface DeleteButtonProps {
    id: string,
    onConfirmed: () => void,
    disabled: boolean,
}

export default function DeleteButton(props: DeleteButtonProps) {
    const [open, setOpen] = useState(false);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, [setOpen]);

    const handleClickOpen = useCallback(() => {
        setOpen(true);
    }, [setOpen]);

    const onAggree = useCallback(() => {
        props.onConfirmed();
        setOpen(false);
    }, [setOpen, props.onConfirmed]);

    return <>
        <Button id={props.id} variant='outlined' color='error' onClick={handleClickOpen} disabled={props.disabled}>
            Delete
        </Button>

        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                {"Delete?"}
            </DialogTitle>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Disagree
                </Button>
                <Button onClick={onAggree} autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>

    </>;
} 